import { defineSlotRecipe as r } from "@pandacss/dev";
import { anatomy as e } from "../../node_modules/@ark-ui/anatomy/node_modules/@zag-js/progress/dist/index.mjs";
const a = r({
  className: "progress",
  slots: e.keys(),
  base: {
    range: {
      borderRadius: "1"
    },
    track: {
      borderRadius: "1"
    }
  }
});
export {
  a as progress
};
